<template>
  <v-dialog :value="value" width="500" persistent>
    <v-card>
      <v-card-title>Quick note</v-card-title>

      <v-card-text>

        <v-row>
          <v-col>
            <v-textarea v-model="note" label="Note" placeholder="Type note here" counter="250" :rules="noteRules" auto-grow outlined dense />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submit" :disabled="disableSave" :loading="getUpdateQuickNoteLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getUpdateQuickNoteLoading">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import { mapActions,mapGetters, mapMutations } from 'vuex';

  export default {

    props: ['value', 'account_id', 'quick_note'],

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getUpdateQuickNote','getUpdateQuickNoteLoading','getUpdateQuickNoteError']),

      disableSave() {
        return this.getUpdateQuickNoteLoading || this.note.length>250;
      },

      accountId() {
        return this.$route.params.id || this.account_id;
      }
    },

    watch: {
      value(val) {
        if(val && this.account_id || this.getCreditControl.quick_note){
          this.note = this.account_id ? this.quick_note : this.getCreditControl.quick_note;
        }
      }
    },

    data() {
      return {
        note: '',
        noteRules: [v => v.length <= 250 || 'Max 250 characters'],
      }
    },

    methods: {
      ...mapActions('creditControl',['updateQuickNote']),
      ...mapMutations('creditControlDashboard', ['UPDATE_CREDIT_CONTROL_ACCOUNTS_LOCAL']),

      async submit() {
        const data = {
          account_id: this.accountId,
          note: this.note ? this.note : null
        };

        await this.updateQuickNote(data);
        if(!this.getUpdateQuickNoteError){
          this.UPDATE_CREDIT_CONTROL_ACCOUNTS_LOCAL({ account_id: data.account_id, payload: { quick_note: data.note } });
          this.close(); 
        }
      },

      close() {
        this.note = '';
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
